import Cookie from 'js-cookie';

export default function removeCookie(name) {
  Cookie.remove(name, {path: '/', expires: 999});
}
